<template>
  <div class="form-row animated fadeIn">
    <div>
      <a href="" @click.prevent="activateFilterTable">
        <i class="fa fa-filter fa-lg"
          :class="{'text-danger': filterActive}">
        </i>
        <i v-if="filterActive"
          class="fa fa-times fa-1 text-danger"></i>
        <span v-if="filterActive" class="text-danger">Remove filter</span>
        <span v-if="!filterActive">Filter</span>
      </a>
    </div>
    <div
      @scroll="onScroll($event)"
      ref="scroll-top-container"
      :style="{'overflow-x': 'auto'}"
      v-if="horizontalTopScroll">
      <div ref="scroll-top-content" :style="{'height': scrollTopHeight + 'px', 'width': scrollTopWidth + 'px'}" ></div>
    </div>
    <table
      ref='table'
      @scroll="onScroll($event)"
      class="table b-table"
      :class="{
        'table-striped': striped,
        'table-responsive': responsive,
        'on-loading': onLoading,
      }">
      <thead>
        <tr>
          <th
            v-for="field in fields"
            @click="updateSort(field)"
            :key="field.key"
            :class="{
              'sorting': field.sortable,
              'sorting_desc': getDirection(field.key) === 'desc',
              'sorting_asc': getDirection(field.key) === 'asc',
            }">
            {{ field.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="filterActive" class="filter-row">
          <td
            v-for="field in fields"
            :key="field.key">
            <b-form-input
              @input="onFilter(field, $event)"
              size="sm"
              type="text"
              v-model="filterFields[field.key]"
              v-if="field.filterable"></b-form-input>
          </td>
        </tr>
        <tr
          v-for="item in items"
          :key="item.no">
          <td
            v-for="field in fields"
            :key="field.key">
            {{ item[field.key] }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { debounce, isEqual, cloneDeep } from 'lodash';

export default {
  name: 'base-table',
  props: {
    items: {
      type: Array,
      default: [],
      required: true,
    },
    fields: {
      type: Array,
      default: [],
      required: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    responsive: {
      type: Boolean,
      default: true,
    },
    horizontalTopScroll: {
      type: Boolean,
      default: true,
    },
    onLoading: {
      type: Boolean,
      default: false,
    },
    reset: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      cloneFields: [],
      sortedFields: [],
      filterFields: {},
      scrollTopWidth: 0,
      scrollTopHeight: 0,
      cacheFields: {},
      filterActive: false,
    };
  },
  watch: {
    reset() {
      const { filterFields, sortedFields } = this;
      sortedFields.splice(0);
      /* eslint-disable */
      for (const key in filterFields) {
        if (filterFields.hasOwnProperty(key)) {
          filterFields[key] = '';
        }
      }
      /* eslint-enable */
    },
    fieldsData(newDataFields) {
      if (!isEqual(newDataFields, this.cacheFields)) {
        this.cacheFields = cloneDeep(newDataFields);
      }
    },
  },
  methods: {
    updateSort(fieldSort) {
      if (!fieldSort.sortable) { return; }
      const { sortedFields } = this;
      const hasSorted = this.sortedFields.find(sorted => sorted.key === fieldSort.key);
      let newDirection;

      if (!hasSorted) {
        sortedFields.push({
          key: fieldSort.key,
          direction: 'asc',
        });
        newDirection = 'asc';
      } else {
        const index = sortedFields.findIndex(sorted => sorted.key === fieldSort.key);
        newDirection = hasSorted.direction === 'asc' ? 'desc' : null;

        if (!newDirection) {
          sortedFields.splice(index, 1);
        } else {
          const sOrder = sortedFields.splice(index, 1);
          sOrder[0].direction = newDirection;
          sortedFields.push(sOrder[0]);
        }
      }

      this.$emit('sort-changed', sortedFields.reverse().map(s => `${s.key}.${s.direction}`));
    },
    onFilter: debounce(function onFilter() {
      this.$emit('on-filter', this.filterFields);
    }, 300),
    onScroll(e) {
      const { tagName } = e.target;
      const elem = tagName === 'TABLE' ?
        this.$refs['scroll-top-container'] : this.$refs.table;
      elem.scrollLeft = e.target.scrollLeft;
    },
    $ready(timeout) {
      setTimeout(() => {
        const tableComponent = this.$refs.table;
        const scrollWidthTable = tableComponent.scrollWidth;
        this.scrollTopWidth = scrollWidthTable;
        this.scrollTopHeight = 2;
        this.cloneFields = cloneDeep(this.fields);
        this.setFilterValue();
      }, timeout);
    },
    setFilterValue() {
      const { fields, filterFields } = this;
      fields.forEach((field) => {
        if (field.filterable) {
          filterFields[field.key] = '';
        }
      });
    },
    activateFilterTable() {
      if (this.isLoading) { return; }
      this.filterActive = !this.filterActive; // eslint-disable-line
      if (!this.filterActive) {
        /* eslint-disable */
        for (const k in this.filterFields) {
          if (this.filterFields.hasOwnProperty(k)) {
            this.filterFields[k] = '';
          }
        }
        /* eslint-enable */
        this.onFilter();
      }
    },
    getDirection(key) {
      const sort = this.sortedFields.find(s => s.key === key);
      if (sort) {
        return sort.direction;
      }
      return null;
    },
  },
  mounted() {
    this.$ready(50);
  },
};
</script>
<style lang="sass">
.on-loading
  opacity: 0.3
.filter-row > td
  padding: 0
.filter-row > td > input
  border-top: none
  border-bottom: none
</style>



// WEBPACK FOOTER //
// src/components/BaseTable.vue